
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/haku",
      function () {
        return require("private-next-pages/haku/index.js");
      }
    ]);
  